/**
 * LEGACY COMPOSABLE - Delegates to useExtraPacksStore
 * 
 * This composable is kept for backward compatibility but now uses the new
 * route-aware store to prevent global loading of extra packs data.
 */
export function useExtraPacks() {
  const route = useRoute();
  const extraPacksStore = useExtraPacksStore();
  
  // Use the store's state
  const extraPacks = computed(() => extraPacksStore.extraPacks);
  
  /**
   * Modified to be route-aware and only fetch on relevant routes
   */
  const fetchExtraPacks = async () => {
    // Check if we're on a relevant route
    const isRelevantRoute = 
      route.path.startsWith('/extra-packs') || 
      (route.path.startsWith('/account/dashboard') && route.query.view === 'extra-roaming');
    
    // Only fetch if on a relevant route
    if (isRelevantRoute) {
      console.log('[useExtraPacks] On relevant route, delegating to store');
      return extraPacksStore.getBasicExtras();
    } else {
      console.log('[useExtraPacks] Not on relevant route, skipping fetch');
      return extraPacksStore.extraPacks;
    }
  };

  return {
    extraPacks,
    fetchExtraPacks,
  };
}
